import { TApplicationState } from 'shared/mf-infrastructure/types/redux';

export const selectIsFullscreenOpen = (state: TApplicationState) => state.fullscreen.isFullscreenOpen;
